import { PageLayout } from '@/components/templates/PageLayout';
import { CmCard, CmHeading, CmScrollBox } from '@/components/uiParts';
import { routes } from '@/router';

import { DeliveryAreaTable } from './components';
import { AuthStoreDeliveryAreas } from './types';

type Props = {
  authStoresDeliveryAreas: AuthStoreDeliveryAreas[];
};

export const DeliveryInHouseTemplate: React.FC<Props> = ({
  authStoresDeliveryAreas,
}) => {
  return (
    <PageLayout title={routes.deliveryInHouse.title}>
      <CmCard
        mt="25px"
        height={`calc(100vh - 120px)`}
        padding={'20px 40px 10px'}
      >
        <CmHeading fontSize="16px" pb="10px">
          配達エリア設定
        </CmHeading>
        <CmScrollBox>
          <DeliveryAreaTable
            authStoresDeliveryAreas={authStoresDeliveryAreas}
          />
        </CmScrollBox>
      </CmCard>
    </PageLayout>
  );
};
